import React from "react"

import { trendFields } from "./GraphFieldTable"

export default function InputTrendField({ obv, field, width, disabled, updateField }) {
  const obv_info = trendFields[field]
  const fieldDisabled =
    !obv_info.editable ||
    disabled ||
    (field === "strokeWidth" && ["points", "box"].includes(obv["style"])) ||
    (field === "pointSize" && ["line", "box"].includes(obv["style"]))
  return (
    <>
      {!fieldDisabled ? (
        <input
          style={{ width: width }}
          type={"number"}
          min={"1"}
          step={"0.5"}
          size={"4"}
          value={obv[field] || ""}
          disabled={fieldDisabled}
          onWheel={(e) => e.target.blur()}
          onChange={(ev) => {
            ev.preventDefault()
            // Make sure the value won't go lower than 0
            updateField(!ev.target.value || ev.target.value <= 0 ? 1 : ev.target.value)
          }}
        />
      ) : (
        <span>{obv[field] || ""}</span>
      )}
    </>
  )
}
